import { Component, OnInit } from '@angular/core';
import * as Highcharts from "highcharts";
import exporting from 'highcharts/modules/exporting';
import HC_more from "highcharts/highcharts-more";
import { AnalyticsService } from '../../../../services/analytics.service';
HC_more(Highcharts);
exporting(Highcharts);

@Component({
  selector: 'app-reports-total-count-card',
  templateUrl: './reports-total-count-card.component.html',
  styleUrls: ['./reports-total-count-card.component.css']
})
export class ReportsTotalCountCardComponent implements OnInit {

  pendingCount:number =0;
  completedCount:number=0;
  updateFromInput: boolean = false;
 //requiredReportchartOptionsString: string =
  RequiredReportsChart: typeof Highcharts = Highcharts;
  requiredReportchartOptions:Highcharts.Options;

  selectedReportYear: number;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {

  }

  loadProgressChart(yearId:number,year:number)
  {

    this.selectedReportYear = year;
    this.analyticsService.getRequiredReportsCountByYear$(yearId).subscribe((data)=>{

      //console.log(data);

      this.pendingCount =data.pendingRequiredReportsCount;
      this.completedCount = data.completedRequiredReportsCount;
      this.GetChartOptions();
      this.updateChart();
    });




  }
  updateChart()
  {
    //console.log(this.requiredReportchartOptionsString);
    //this.requiredReportchartOptions =JSON.parse(this.requiredReportchartOptionsString);
    this.updateFromInput = true;
  }
   GetChartOptions()
   {
    this.requiredReportchartOptions=
    {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        width:450,
        height:375,

    },
    title: {
        text: 'Required  Reports Progress for ' + this.selectedReportYear,
        style:{"color":"#337ab7","fontSize":"16px","fontWeight":"bold" }
    },

    tooltip: {
         pointFormat: '{point.percentage:.1f}%'


    },

    plotOptions: {
        pie: {
            dataLabels: {
                enabled: false
            },
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
            size: '120%'
        }
    },
    credits:{
      enabled:false
    },

  legend: {
        align: 'center',
        verticalAlign: 'bottom',
        x: 0,
        y: 0
    },
    series: [{
        type: 'pie',
        name: 'Required Reports Progress',
        innerSize: '70%',
        startAngle: -90,
        endAngle: 90,
        showInLegend: true,
        data: [
             {

                name: 'Completed: ' + this.completedCount,
                y:this.completedCount,
               color:Highcharts.getOptions().colors[7]
              },

              {

                name: 'Pending: ' + this.pendingCount,
                y:this.pendingCount,
                color: Highcharts.getOptions().colors[3]

              }
        ]
    }]

    };
   }



}
